import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserInvitationByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type GetUserInvitationByEmailQuery = { __typename?: 'query_root', user_invitations: Array<{ __typename?: 'user_invitations', id: any, email: string, status: string }> };


export const GetUserInvitationByEmailDocument = gql`
    query getUserInvitationByEmail($email: String!) {
  user_invitations(where: {email: {_eq: $email}}, limit: 1) {
    id
    email
    status
  }
}
    `;

/**
 * __useGetUserInvitationByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserInvitationByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitationByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitationByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserInvitationByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables> & ({ variables: GetUserInvitationByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>(GetUserInvitationByEmailDocument, options);
      }
export function useGetUserInvitationByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>(GetUserInvitationByEmailDocument, options);
        }
export function useGetUserInvitationByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>(GetUserInvitationByEmailDocument, options);
        }
export type GetUserInvitationByEmailQueryHookResult = ReturnType<typeof useGetUserInvitationByEmailQuery>;
export type GetUserInvitationByEmailLazyQueryHookResult = ReturnType<typeof useGetUserInvitationByEmailLazyQuery>;
export type GetUserInvitationByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserInvitationByEmailSuspenseQuery>;
export type GetUserInvitationByEmailQueryResult = Apollo.QueryResult<GetUserInvitationByEmailQuery, GetUserInvitationByEmailQueryVariables>;